import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { ILocationType } from './typings'
import { getLocationTypes } from './api'

const locationTypeAdapter = createEntityAdapter<ILocationType>({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
})

export const locationTypeDisplayName = (s: ILocationType) =>
  s.description.trim() == '' ? s.name : `${s.name}- ${s.description}`

export const initialState = locationTypeAdapter.getInitialState()

const locationTypes = createSlice({
  name: 'locationTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLocationTypes.fulfilled, (state, { payload }) => {
      locationTypeAdapter.setAll(state, payload)
    })
    builder.addCase(getLocationTypes.pending, (state) => {
      locationTypeAdapter.removeAll(state)
    })
  },
})

export default locationTypes.reducer

export const locationTypeAdapterSelectors =
  locationTypeAdapter.getSelectors<StoreData>((state) => state.locationTypes)

export const {
  selectAll: selectAllLocationTypes,
  selectById: selectLocationTypeById,
} = locationTypeAdapterSelectors
